
export class uploadcvpojo{
    id: number | any;
    fullName: string ;
    phoneNo: string ;
    mailId: string ;
    message: String;
    date:string;
}